import React, { useState } from "react";
import DrawerFilter from "../../../../../components/listing/DrawerFilter";
import InputNumberNoScroll from "../../../../../components/inputs/inputNumberNoScroll";

export default function FiltroIva({ initialFilters = {}, onSubmit = () => {}, onClose = () => {} }) {
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [pr, setPr] = useState(initialFilters.pr || "");

  const handleApply = () => {
    onSubmit({
      codigo: codigo.trim(),
      nombre: nombre.trim(),
      pr: pr === "" ? undefined : Number(pr),
    });
    onClose();
  };

  return (
    <DrawerFilter title="Filtros de IVA" onClose={onClose} onApply={handleApply}>
      <div className="space-y-4">
        <div><label className="form-label-fil">Código:</label><input type="text" className="input mt-1 w-full" value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="Buscar por código..." /></div>
        <div><label className="form-label-fil">Descripción:</label><input type="text" className="input mt-1 w-full" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Buscar por nombre..." /></div>
        <div>
          <label className="form-label-fil">Porcentaje:</label>
          <InputNumberNoScroll
            step="1"
            className="input mt-1 w-full"
            value={pr}
            onChange={e => setPr(e.target.value === "" ? "" : Number(e.target.value))}
            placeholder="Buscar por % IVA..."
          />
        </div>
      </div>
    </DrawerFilter>
  );
}